import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import 'flatpickr/dist/flatpickr.css';
import flatPickr from 'vue-flatpickr-component';
Vue.component('flat-pickr', flatPickr);
import storage from './util/storage';
Vue.prototype.$addStorage = storage;
import 'remixicon/fonts/remixicon.css';

import BootstrapVue from 'bootstrap-vue'

import globals from './globals'
import Popper from 'popper.js'
import axios from 'axios'
import VueI18n from 'vue-i18n'
import store from './store/store'
Vue.prototype.changeDeleteLoading = (val) => {
  store.commit('changeDeleteLoading', val);
};

import './common/css/list.css' /*引入公共样式*/
import utils from './util/util'
import cookie from './util/cookie'

import jaLcale from 'element-ui/lib/locale/lang/ja'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'


Vue.use(store)

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false

Vue.prototype.utils = utils;
Vue.prototype.cookie = cookie;
Vue.prototype.another = (str)=>{
  if(typeof str=='object'){
    return JSON.parse(JSON.stringify(str))
  }else{
    return str
  }
}
import '@/util/power' //路由守卫

Vue.use(ElementUI,{
  i18n: (key, value) => i18n.t(key, value) //使用element的语言包
})
Vue.config.productionTip = false
Vue.use(VueI18n)
var lang = navigator.language || navigator.userLanguage
let a

if(!localStorage.lastname){
  if (lang == "zh-cn") {
    a = 'zh'
    localStorage.lastname = 'zh'
    
  }else{
    a = 'ja'
    localStorage.lastname = 'ja'
  }
}else{
  if(localStorage.lastname == "ja"){
    a='ja'
  }else{
    a='zh'
  }

}

const messages = {
  'zh': { // 中文包
    ...require('./common/lang/zh-CN'),
    ...zhLocale
  },
  'ja': { // 日文包
    ...require('./common/lang/ja'),
    ...jaLcale
  }
}

Vue.prototype.getPermission = function (which){
  let permission = {}
  let role = JSON.parse(localStorage.getItem('role'));
  for ( let k in role ) {
    if(which == k){
      permission = role[k]
    }
  }
  return permission;
}

Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'data') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        localStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal);
  }
}




const i18n = new VueI18n({
  locale: a,
  messages: messages
})
Vue.use(BootstrapVue)

// Global RTL flag
Vue.mixin({
  data: globals
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')




